import { DefectV10 } from './defectV10';
import { FlatRateUnitV10 } from './flatRateUnitV10';
import { PartV10 } from './partV10';
export class PackageV10 {
    static constructFromPlainObject(sourcePackage) {
        const servicePackage = new PackageV10(sourcePackage.description, sourcePackage.number, sourcePackage.type, sourcePackage.defects, sourcePackage.flatRateUnits, sourcePackage.parts, sourcePackage.campaignBegin, sourcePackage.campaignName, sourcePackage.campaignNumber);
        servicePackage.setPositionNumber(sourcePackage.positionNumber);
        servicePackage.setSelected(!!sourcePackage.selected);
        return servicePackage;
    }
    constructor(description, number, type, defects = [], flatRateUnits = [], parts = [], campaignBegin, campaignName, campaignNumber) {
        this.description = description;
        this.number = number;
        this.type = type;
        this.defects = defects;
        this.flatRateUnits = flatRateUnits;
        this.parts = parts;
        this.campaignBegin = campaignBegin;
        this.campaignName = campaignName;
        this.campaignNumber = campaignNumber;
        this.selected = false;
        this.defects = defects.map((d) => DefectV10.constructFromPlainObject(d));
        this.flatRateUnits = flatRateUnits.map((f) => FlatRateUnitV10.constructFromPlainObject(f));
        this.parts = parts.map((p) => PartV10.constructFromPlainObject(p));
    }
    getCampaignBegin() {
        return this.campaignBegin;
    }
    getCampaignName() {
        return this.campaignName;
    }
    getCampaignNumber() {
        return this.campaignNumber;
    }
    getDefects() {
        return this.defects;
    }
    getDescription() {
        return this.description;
    }
    getFlatRateUnits() {
        return this.flatRateUnits;
    }
    getNumber() {
        return this.number;
    }
    getParts() {
        return this.parts;
    }
    getType() {
        return this.type;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}
//# sourceMappingURL=packageV10.js.map